export default __webpack_public_path__ + "static/media/022-graphic design.c31a0f2e.svg";